export default __webpack_public_path__ + "static/blackfortheader1-1eae76773f75a3ca8ae516b5dce00eaf.webm";